const ARUPADAI_VEEDU_IDS = new Set([
  'tn_thiruvenkatam_tirupati',
  'tn_palani_murugan',
  'tn_madurai_thiruparankundram',
  'tn_tiruchendur_murugan',
  'tn_swamimalai_murugan',
  'tn_pazhamudircholai_murugan',
]);

export const CIRCUITS = [
  {
    id: 'navagraha',
    name_en: 'Navagraha Circuit',
    name_hi: 'नवग्रह परिपथ',
    icon: '🪐',
    tagline_en: '9 celestial temples · Tamil Nadu',
    tagline_hi: '9 ग्रह मंदिर · तमिलनाडु',
    desc_en: 'Nine Shiva temples in the Kaveri delta, each presided by a different celestial body — Sun through Ketu. Visiting all nine is believed to mitigate the malefic effects of the nine planets.',
    desc_hi: 'कावेरी डेल्टा में नौ शिव मंदिर, प्रत्येक एक अलग ग्रह को समर्पित — सूर्य से केतु तक। सभी नौ के दर्शन से नवग्रहों के अशुभ प्रभाव कम होते हैं।',
    color: '#c9922a',
    bgColor: 'rgba(201,146,42,0.08)',
    borderColor: 'rgba(201,146,42,0.25)',
    states: ['tamil_nadu'],
    match: (t) => /navagraha/i.test(t.deity_en || '') || /vaitheeswaran/i.test(t.deity_en || ''),
  },
  {
    id: 'pancha_bhuta',
    name_en: 'Pancha Bhuta Stalams',
    name_hi: 'पंच भूत स्थलम',
    icon: '🌊',
    tagline_en: '5 elements · Tamil Nadu & Andhra Pradesh',
    tagline_hi: '5 तत्व · तमिलनाडु और आंध्र प्रदेश',
    desc_en: 'Five ancient Shiva temples representing the five elements of creation: Earth (Kanchipuram), Water (Thiruvanaikaval), Fire (Tiruvannamalai), Air (Srikalahasti), and Ether (Chidambaram).',
    desc_hi: 'पांच प्राचीन शिव मंदिर, सृष्टि के पांच तत्वों का प्रतिनिधित्व करते हैं: पृथ्वी (कांचीपुरम), जल (तिरुवनैकवल), अग्नि (तिरुवन्नामलै), वायु (श्रीकालहस्ती), और आकाश (चिदंबरम)।',
    color: '#1a6b9a',
    bgColor: 'rgba(26,107,154,0.08)',
    borderColor: 'rgba(26,107,154,0.25)',
    states: ['tamil_nadu', 'andhra_pradesh'],
    match: (t) => /prithvi lingam|appu lingam|fire lingam|akasha lingam|vayu lingam/i.test(t.deity_en || ''),
  },
  {
    id: 'arupadai_veedu',
    name_en: 'Arupadai Veedu',
    name_hi: 'अरुपदै वीडु',
    icon: '🪷',
    tagline_en: '6 abodes of Murugan · Tamil Nadu',
    tagline_hi: '6 मुरुगन धाम · तमिलनाडु',
    desc_en: 'Six sacred abodes of Lord Murugan, each representing a different episode from the Skanda Purana. Together they form the most important pilgrimage circuit of Tamil Shaivism.',
    desc_hi: 'भगवान मुरुगन के छह पवित्र धाम, प्रत्येक स्कंद पुराण के एक अलग प्रसंग को दर्शाता है। मिलकर ये तमिल शैवधर्म का सबसे महत्वपूर्ण तीर्थ परिपथ बनाते हैं।',
    color: '#b5500a',
    bgColor: 'rgba(181,80,10,0.08)',
    borderColor: 'rgba(181,80,10,0.25)',
    states: ['tamil_nadu'],
    match: (t) => ARUPADAI_VEEDU_IDS.has(t.id),
  },
  {
    id: 'divya_desam',
    name_en: 'Divya Desams',
    name_hi: 'दिव्य देसम',
    icon: '☸',
    tagline_en: '108 Vishnu temples · Āḻvār canon',
    tagline_hi: '108 विष्णु मंदिर · अल्झवार संकलन',
    desc_en: '108 sacred Vishnu temples celebrated in the Nalayira Divya Prabandham by the 12 Āḻvār saints (6th–9th c. CE). Visiting all 108 is the supreme act of Vaishnava devotion in South India.',
    desc_hi: '12 अल्झवार संतों द्वारा नालयिर दिव्य प्रबंधम में गाए गए 108 पवित्र विष्णु मंदिर। सभी 108 की यात्रा दक्षिण भारत में वैष्णव भक्ति का सर्वोच्च कार्य है।',
    color: '#c9922a',
    bgColor: 'rgba(201,146,42,0.06)',
    borderColor: 'rgba(201,146,42,0.2)',
    states: ['tamil_nadu', 'kerala', 'andhra_pradesh'],
    match: (t) => t.alzhwar_star === true,
  },
  {
    id: 'paadal_petra',
    name_en: 'Paadal Petra Sthalams',
    name_hi: 'पादल पेट्र स्थलम',
    icon: '🔱',
    tagline_en: '276 Shiva temples · Nayanmars canon',
    tagline_hi: '276 शिव मंदिर · नयनमार संकलन',
    desc_en: '276 Shiva temples sung in the Thevaram by the three principal Nayanmars — Appar, Sambandar, and Sundarar. Only temples sung in verse are considered Paadal Petra Sthalams.',
    desc_hi: 'तीन प्रमुख नयनमारों — अप्पर, संबंदर और सुंदरर — द्वारा थेवारम में गाए गए 276 शिव मंदिर। केवल वे मंदिर जो छंदों में गाए गए हैं, पादल पेट्र स्थलम माने जाते हैं।',
    color: '#7b4fd4',
    bgColor: 'rgba(123,79,212,0.07)',
    borderColor: 'rgba(123,79,212,0.22)',
    states: ['tamil_nadu'],
    match: (t) => t.nayanmars_star === true,
  },
];
